// Endocrine subsection questionnaire constants
export enum EndocrineQuestionnaireItem {
  MEDICAL_BACKGROUND_ENDOCRINE = 'medical-background/endocrine',
  MEDICAL_BACKGROUND_ENDOCRINE_ENDOCRINE_WNL = 'medical-background/endocrine/endocrine-wnl',
  MEDICAL_BACKGROUND_ENDOCRINE_MENSTRUAL_CYCLE = 'medical-background/endocrine/menstrual-cycle',
  MEDICAL_BACKGROUND_ENDOCRINE_MENSTRUAL_DATE = 'medical-background/endocrine/menstrual-date',
  MEDICAL_BACKGROUND_ENDOCRINE_ENDOCRINE_NOTES = 'medical-background/endocrine/endocrine-notes',
  MEDICAL_BACKGROUND_ENDOCRINE_SYSTEM_SUMMARY = 'medical-background/endocrine/system-summary'
}
